import { IOT_SIM_LIST_LOOKUP } from "api/ApiPath";
import client from "api/client";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IIOTSimListLookupRepository } from "../domain/repositories/IIOTSimListLookupRepository";
import { injectable } from "tsyringe";
import { IOTSimListLookupResponseModel } from "./model/IOTSimListLookupResponseModel";
import { IOTSimListLookupListRequestEntity } from "../domain/entities/IOTSimListLookupListRequestEntity";

@injectable()
export class IOTSimListLookupImpl implements IIOTSimListLookupRepository {
  async getList(
    formData: FormData,
  ): Promise<ListBaseApiResponseModel<IOTSimListLookupResponseModel>> {
    return await client.post(IOT_SIM_LIST_LOOKUP.LIST, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  async exportExcel(formData: FormData): Promise<ArrayBuffer> {
    return await client.exportPost(IOT_SIM_LIST_LOOKUP.EXPORT_EXCEL, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  async downloadTemplate(params: IOTSimListLookupListRequestEntity): Promise<ArrayBuffer> {
    return await client.export(IOT_SIM_LIST_LOOKUP.DOWNLOAD_TEMPLATE, params);
  }
}
